import { useCommonData } from '@/hooks';
import { computed, ref } from 'vue';
import { WEBIRM_HOST } from '@/const/host';
import SLIDE_BANNER from '@/assets/images/slide/slide_banner.png';

const useCurrentReactive = () => {
    const { viewInIframe, isSlideTmpl } = useCommonData();
    const isEnableUpload = computed(() => viewInIframe.value);

    // 如果地址栏包括了 storeId/pageId，则判定为会进行数据刷新的场景
    // 如果没有，就从缓存中获取
    const realRenderBanner = ref('');
    const bannerRendered = ref(false);
    const create = imgUrl => {
        if (!imgUrl) {
            // TODO 侧边栏先给一个默认banner 接入配置后可移除
            if (isSlideTmpl.value) {
                realRenderBanner.value = SLIDE_BANNER;
                bannerRendered.value = true;
                return;
            }

            realRenderBanner.value = '';
            return;
        }
        const imgElement = document.createElement('img');
        imgElement.src = imgUrl;
        imgElement.onload = () => {
            realRenderBanner.value = imgUrl;
            bannerRendered.value = true;
        };
    };

    const handleUploadBanner = () => {
        // 向外通知接口更新
        parent.postMessage(
            {
                updateMessage: {
                    showUploadBox: true
                }
            },
            WEBIRM_HOST
        );
    };

    return {
        isEnableUpload,
        realRenderBanner,
        bannerRendered,
        create,
        handleUploadBanner
    }
}


export { useCurrentReactive };